module.exports = __webpack_public_path__ + "img/icon-refund.878b8ce9.svg";